export default __webpack_public_path__ + "static/media/geometry-artwork-11.2e7a149f.webp";